import AppLayout from "@amzn/meridian/app-layout";
import React, { useState } from "react";
import { Outlet, useLocation, ScrollRestoration } from "react-router-dom";
import Button from "@amzn/meridian/button";
import Icon from "@amzn/meridian/icon";
import sparklesSmallTokens from "@amzn/meridian-tokens/base/icon/sparkles-small";
import { AuthWrapper } from "../../components/auth/AuthWrapper";
import { PageContextProvider } from "../../components/context-provider/PageContextProvider";
import ErrorBoundary from "../../components/error-boundary";
import { HeaderComponent } from "../../components/header/HeaderComponent";
import { AIChatModal } from "../../components/ai-chat-modal/AIChatModal";
import { Breadcrumbs } from "../../features/breadcrumbs/Breadcrumbs";
import { Sheets } from "../../features/sheets/Sheets";
import styles from "./style.module.scss";

export const Layout: React.FC = () => {
    const { pathname } = useLocation();
    const [isAIChatOpen, setIsAIChatOpen] = useState(false);

    return (
        <AuthWrapper>
            <ErrorBoundary>
                <PageContextProvider>
                    <AppLayout
                        backgroundColor={pathname.split("/")[1] === "" ? "subdued" : "principal"}
                        sheetComponent={Sheets}
                        alwaysShowScrollbar={false}
                    >
                        <HeaderComponent />
                        <div className={styles.layout}>
                            <Breadcrumbs />
                            <Outlet />
                        </div>
                        <Sheets />
                    </AppLayout>
                    {/* Floating AI Chat Button */}
                    <Button
                        type="primary"
                        size="large"
                        onClick={() => setIsAIChatOpen(true)}
                        className={styles.floatingAIButton}
                    >
                        <Icon tokens={sparklesSmallTokens} />
                        Ask Appraiser AI
                    </Button>

                    {/* AI Chat Modal */}
                    <AIChatModal isOpen={isAIChatOpen} onClose={() => setIsAIChatOpen(false)} />
                </PageContextProvider>
            </ErrorBoundary>
            <ScrollRestoration getKey={location => location.pathname} />
        </AuthWrapper>
    );
};
